<template>
  <div class="niu_danji">
    <div class="notice">
      <div class="movenotice">
        <div class="itemnotice">
          手机号：177****8455 抽中 调音器 手机号：139****6530 抽中 天才小鼓手
          手机号：185****4785 抽中 音乐窝文化衫 手机号：137****5637 抽中
          吉他手成长必修秘笈 手机号：132****5631 抽中 VGM声学院入门篇
          手机号：189****3260 抽中 小白成长记
        </div>
        <!-- <div class="itemnotice">手机号码：188*****8888 抽中xxxxx</div> -->
      </div>
    </div>
    <div class="niudantitle">
      <img src="../assets/img/luckDraw/title.png" alt="" />
    </div>
    <!--机器-->
    <div class="game_qu">
      <!--球-->
      <div class="dan_gund">
        <span
          :class="['qiu_1 qiuafter', movebtn ? 'wieyi_1' : 'diaol_1']"
        ></span>
        <span
          :class="['qiu_2 qiuafter', movebtn ? 'wieyi_2' : 'diaol_2']"
        ></span>
        <span
          :class="['qiu_3 qiuafter', movebtn ? 'wieyi_3' : 'diaol_3']"
        ></span>
        <span
          :class="['qiu_4 qiuafter', movebtn ? 'wieyi_4' : 'diaol_4']"
        ></span>
        <span
          :class="['qiu_5 qiuafter', movebtn ? 'wieyi_5' : 'diaol_5']"
        ></span>
        <span
          :class="['qiu_6 qiuafter', movebtn ? 'wieyi_6' : 'diaol_6']"
        ></span>
        <span
          :class="['qiu_7 qiuafter', movebtn ? 'wieyi_7' : 'diaol_7']"
        ></span>
      </div>
      <!--go-->
      <div class="game_go"></div>
      <div class="medon"></div>
      <!--中奖掉落-->
      <div class="zjdl">
        <span :class="{ none: zjdl == false, diaL_one: zjdl == true }"></span>
      </div>
    </div>
    <div
      :class="[frequency == 0 ? 'niudanbtnone' : 'niudanbtn']"
      @click="game_go"
    >
      抽奖({{ frequency }}次)
    </div>
    <div class="sidebar">
      <div @click="prizeclick">
        <img src="../assets/img/luckDraw/prize.png" alt="" />
      </div>
      <div @click="ruleclick">
        <img src="../assets/img/luckDraw/rule.png" alt="" />
      </div>
    </div>
    <div class="textbottom">本活动最终解释权归音乐窝所有，与苹果公司无关。</div>
    <div class="darkbox" v-if="darkbtn">
      <div class="rulebox" v-if="rulebtn">
        <div class="ruleclose" @click="ruleclick">
          <img src="../assets/img/luckDraw/closerule.png" alt="" />
        </div>
        <div class="ruletitle">
          <div>规则</div>
          <div class="ruledatabody">{{ ruledata }}</div>
        </div>
      </div>
      <div class="prizebox" v-if="prizebtn">
        <div class="prizeboxclose" @click="prizeclick">
          <img src="../assets/img/luckDraw/closerule.png" alt="" />
        </div>
        <div class="prizesm">
          <div
            class="prizesmbox"
            v-for="(item, index) in prizeList"
            :key="index"
          >
            <div class="prizesmboximg">
              <img :src="item.cover_image_url" alt="" />
            </div>
            <div class="prizesmtitle">
              {{ item.title }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import wx from "weixin-js-sdk";
import qs from "qs";
export default {
  name: "preheat",
  data() {
    return {
      movebtn: false,
      zjdl: false,
      rulebtn: false,
      prizebtn: false,
      darkbtn: false,
      ruledata: "",
      prizeList: [],
      token: "",
      activity_id: "",
      frequency: "0",
      type: "",
      nonetext: "",
    };
  },
  computed: {},
  components: {},
  methods: {
    prizeclick() {
      this.darkbtn = !this.darkbtn;
      this.prizebtn = !this.prizebtn;
    },
    ruleclick() {
      this.darkbtn = !this.darkbtn;
      this.rulebtn = !this.rulebtn;
    },
    game_go() {
      var _t = this;
      if (_t.frequency == 0) {
        if (_t.nonetext != "") {
          _t.$toast(_t.nonetext);
        }
        return;
      }
      this.draw();
    },
    draw() {
      var _t = this;
      _t.movebtn = true;
      setTimeout(() => {
        _t.getLuckDraw();
      }, 2000);
    },
    // 规矩
    get_activity_rule(id) {
      var _t = this;
      this.$API
        .get_activity_rule({
          activity_id: id,
        })
        .then((res) => {
          // console.log(res.data.rule);
          _t.ruledata = res.data.rule;
          document.title = res.data.title;
        });
    },
    // 物品
    get_activity_luck_draw(id) {
      var _t = this;
      this.$API
        .get_activity_luck_draw({
          activity_id: id,
          page: 1,
          page_size: 30,
        })
        .then((res) => {
          // console.log(res.data.list);
          _t.prizeList = res.data.list;
        });
    },
    // 获取当前用户(某活动)剩余的抽奖次数
    get_user_lottery_num() {
      var _t = this;
      var data = {
        activity_id: _t.activity_id,
        source_type: _t.type,
      };
      var headers = "";
      if (_t.type == 2) {
        headers = {
          "Content-Type": "application/x-www-form-urlencoded",
          token: _t.token,
          "X-APP-NAME": "musicwow",
          "X-DEVICE-TYPE": 3,
        };
      } else {
        var u = navigator.userAgent;
        var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //IOS端
        if (isIos) {
          headers = {
            "Content-Type": "application/x-www-form-urlencoded",
            "yw-token": _t.token,
            "X-APP-NAME": "musicwow",
            "X-DEVICE-TYPE": 2,
          };
        } else {
          headers = {
            "Content-Type": "application/x-www-form-urlencoded",
            "yw-token": _t.token,
            "X-APP-NAME": "musicwow",
            "X-DEVICE-TYPE": 1,
          };
        }
      }
      _t.$ajax({
        headers: headers,
        url:
          process.env.VUE_APP_CONT_API + "api/v1/lottery/get_user_lottery_num",
        method: "post",
        data: qs.stringify(data),
      }).then(function(res) {
        _t.frequency = res.data.data.lottery_num;
      });
    },
    // 抽奖
    getLuckDraw() {
      var _t = this;
      var data = {
        activity_id: _t.activity_id,
        source_type: _t.type,
      };
      var headers = "";
      if (_t.type == 2) {
        headers = {
          "Content-Type": "application/x-www-form-urlencoded",
          token: _t.token,
          "X-APP-NAME": "musicwow",
          "X-DEVICE-TYPE": 3,
        };
      } else {
        var u = navigator.userAgent;
        var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //IOS端
        if (isIos) {
          headers = {
            "Content-Type": "application/x-www-form-urlencoded",
            "yw-token": _t.token,
            "X-APP-NAME": "musicwow",
            "X-DEVICE-TYPE": 2,
          };
        } else {
          headers = {
            "Content-Type": "application/x-www-form-urlencoded",
            "yw-token": _t.token,
            "X-APP-NAME": "musicwow",
            "X-DEVICE-TYPE": 1,
          };
        }
      }
      _t.$ajax({
        headers: headers,
        url: process.env.VUE_APP_CONT_API + "api/v1/lottery",
        method: "post",
        data: qs.stringify(data),
      }).then(function(res) {
        _t.movebtn = false;
        if (res.data.error_code != 0) {
          _t.$toast(res.data.message);
          return;
        }

        _t.zjdl = true;
        if (res.data.data.is_lucky == 1) {
          if (_t.type == 2) {
            _t.$dialog
              .alert({
                message: `恭喜您获得： \n ${
                  res.data.data.prize_title
                } \n 请前往音乐窝APP \n [我的-获奖记录-兑换]`,
                confirmButtonText: "关闭",
              })
              .then(() => {
                _t.zjdl = false;
              })
              .catch(() => {
                _t.zjdl = false;
              });
          } else {
            if (res.data.data.is_entity == 1) {
              _t.$dialog
                .confirm({
                  message: `恭喜你获得${res.data.data.prize_title}确定兑换？`,
                })
                .then(() => {
                  _t.zjdl = false;
                  var u = navigator.userAgent;
                  var isAndroid =
                    u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //安卓端
                  var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //IOS端
                  if (isIos) {
                    _t.zjdl = false;
                    window.location = "skipMyPrize";
                  } else {
                    _t.zjdl = false;
                    App.skipMyPrize();
                  }
                })
                .catch(() => {
                  _t.zjdl = false;
                });
            } else {
              _t.$dialog
                .alert({
                  message: `恭喜你获得${res.data.data.prize_title}`,
                })
                .then(() => {
                  _t.zjdl = false;
                  var u = navigator.userAgent;
                  var isAndroid =
                    u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //安卓端
                  var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //IOS端
                  if (isIos) {
                    _t.zjdl = false;
                  } else {
                    _t.zjdl = false;
                  }
                })
                .catch(() => {
                  _t.zjdl = false;
                });
            }
          }
        } else if (res.data.data.is_lucky == 2) {
          _t.$dialog
            .alert({
              message: `谢谢参与，再接再厉吧`,
              confirmButtonText: "关闭",
            })
            .then(() => {
              _t.zjdl = false;
            })
            .catch(() => {
              _t.zjdl = false;
            });
        }
        _t.get_user_lottery_num();
      });
    },
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");

      var url = decodeURI(decodeURI(window.location.search)); //获取url中"?"符后的字串，使用了两次decodeRUI解码

      var r = url.substr(1).match(reg); //匹配目标参数
      if (r != null) return unescape(r[2]);
      return null; //返回参数值
    },
    // 获取token
    getQueryVariable(item) {
      var sValue = window.location.href.match(
        new RegExp("[?&]" + item + "=([^&]*)(&?)", "i")
      );
      return sValue ? sValue[1] : sValue;
    },
  },
  mounted() {
    var _t = this;
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
      wx.miniProgram.getEnv((res) => {
        if (res.miniprogram) {
          _t.type = 2;
          _t.nonetext = "APP还可继续抽奖";
        } else {
          _t.type = 1;
          _t.nonetext = "小程序还可继续抽奖";
        }
        if (!!_t.getQueryVariable("activity_id")) {
          _t.activity_id = _t.getQueryVariable("activity_id");
          _t.token = _t.getQueryVariable("token");
          _t.get_activity_rule(_t.activity_id);
          _t.get_activity_luck_draw(_t.activity_id);
          _t.get_user_lottery_num();
        }
      });
    } else {
      _t.type = 1;
      _t.nonetext = "小程序还可继续抽奖";
      if (!!_t.getQueryVariable("activity_id")) {
        _t.activity_id = _t.getQueryVariable("activity_id");
        _t.token = _t.getQueryVariable("token");
        _t.get_activity_rule(_t.activity_id);
        _t.get_activity_luck_draw(_t.activity_id);
        _t.get_user_lottery_num();
      }
    }
  },
  created() {},
  beforecreate() {},
};
</script>
<style lang="scss" scoped>
* {
  padding: 0px;
  margin: 0px;
  font-family: "微软雅黑";
  font-size: 100%;
  font-style: normal;
}
dd,
dl,
dt,
em,
i,
p,
textarea,
a,
div {
  padding: 0px;
  margin: 0px;
}
a {
  text-decoration: none;
}
img {
  border: 0px;
}
ul,
li {
  padding: 0px;
  margin: 0px;
  list-style: none;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
body {
  margin: 0px;
  padding: 0px;
  color: #ffc476;
  background: #fff;
  color: #000000;
}
a {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
}
.none {
  display: none;
}

#app {
  width: 100%;
  height: 100%;
}
/*扭蛋机*/
.niu_danji {
  width: 100%;
  height: 100%;
  background: url(../assets/img/luckDraw/bg.png);
  margin: 0px auto;
  overflow: hidden;
  position: fixed;
  background-size: 100% 100%;
  top: 0;
  left: 0;
}

.niudantitle {
  position: absolute;
  width: 256px;
  height: 49px;
  left: 50%;
  margin-left: -128px;
  top: 50px;
  z-index: 10;
}
.niudantitle img {
  width: 100%;
  height: 100%;
}
.niu_danji .game_qu {
  background: url(../assets/img/luckDraw/game_ndj.png) no-repeat;
  width: 263px;
  height: 363px;
  margin: 0 auto;
  left: 50%;
  margin-left: -126.5px;
  background-size: 100% 100%;
  position: absolute;
  z-index: 3;
  bottom: 20%;
}
.niu_danji .game_go {
  width: 93px;
  height: 93px;
  position: absolute;
  left: 50%;
  margin-left: -46.5px;
  bottom: 25%;
  font-size: 18px;
  color: #fff;
  text-align: center;
}

.niu_danji .wdjifen {
  font-size: 20px;
  color: #e00b37;
  width: 128px;
  height: 35px;
  line-height: 35px;
  position: absolute;
  left: 50%;
  margin-left: -64px;
  bottom: 115px;
  text-align: center;
}
.niu_danji .an_jfgr {
  width: 100%;
  text-align: center;
  padding-top: 23px;
  position: absolute;
  left: 0px;
  bottom: 60px;
}

.niu_danji .an_jfgr img {
  margin: 0px 7px;
}

.niu_danji .dan_gund {
  width: 242px;
  height: 210px;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  left: 50%;
  margin-left: -121px;
  -webkit-border-radius: 240px 240px 0px 0px;
  -moz-border-radius: 240px 240px 0px 0px;
  border-radius: 240px 240px 0px 0px;
  overflow: hidden;
}

.niu_danji .medon {
  width: 86px;
  height: 88px;
  position: absolute;
  left: 50%;
  bottom: -2px;
  margin-left: -48px;
  z-index: 1;
}
.niu_danji .medon img {
  width: 100%;
  height: 100%;
}
.niu_danji .dan_gund span {
  width: 50px;
  height: 50px;
}

.niu_danji .zjdl {
  width: 86px;
  height: 88px;
  position: absolute;
  left: 50%;
  bottom: -2px;
  margin-left: -48px;
  z-index: 2;
}
.niudanbtn {
  width: 205px;
  height: 50px;
  padding-bottom: 14px;
  background: url(../assets/img/luckDraw/btn.png) no-repeat;
  display: flex;
  font-size: 26px;
  align-items: center;
  font-weight: 600;
  position: absolute;
  bottom: 5%;
  background-size: 100% 100%;
  left: 50%;
  margin-left: -102.5px;
  color: #fff;
  justify-content: center;
}
.niudanbtnone {
  width: 205px;
  height: 50px;
  padding-bottom: 14px;
  background: url(../assets/img/luckDraw/btnone.png) no-repeat;
  display: flex;
  font-size: 26px;
  align-items: center;
  font-weight: 600;
  position: absolute;
  bottom: 5%;
  background-size: 100% 100%;
  left: 50%;
  margin-left: -102.5px;
  color: #fff;
  justify-content: center;
}
.sidebar {
  height: 87px;
  width: 54px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  position: absolute;
  right: 0;
  top: 23%;
}
.sidebar div {
  width: 54px;
  height: 29px;
}
.sidebar div img {
  height: 100%;
  width: 100%;
}
.notice {
  width: 336px;
  height: 24px;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  margin: 0 auto;
  margin-top: 11px;
  overflow: hidden;
  white-space: nowrap;
  position: relative;
  display: flex;
  align-items: center;
}
.textbottom {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.5);
  position: absolute;
  bottom: 5px;
  width: 100%;
  text-align: center;
}
.movenotice {
  position: absolute;
  left: 100%;
  white-space: nowrap;
  animation: moveAni 15s infinite linear normal;
  display: flex;
}
.itemnotice {
  font-size: 12px;
  color: #fff;
}
@keyframes moveAni {
  0% {
    left: 0;
  }
  100% {
    left: -100%;
  }
}
/*中奖*/
.zonj_zezc {
  width: 640px;
  min-height: 1039px;
  position: absolute;
  left: 50%;
  top: 0px;
  z-index: 4;
  background: rgba(0, 0, 0, 0.85);
  margin-left: -320px;
}
.zonj_zezc .jpzs {
  width: 450px;
  height: 286px;
  position: relative;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  background: #fff;
  margin: 300px auto 0px auto;
  position: relative;
}
.zonj_zezc .jpzs em {
  height: 95px;
  position: absolute;
  right: 0px;
  top: -50px;
}
.zonj_zezc .jpzs h2 {
  font-size: 36px;
  color: #ff1a4b;
  text-align: center;
  line-height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 286px;
}
.qiu_1 {
  position: absolute;
  left: 0px;
  top: 160px;
}
.qiu_2 {
  position: absolute;
  left: 50px;
  top: 160px;
}
.qiu_3 {
  position: absolute;
  left: 100px;
  top: 150px;
}
.qiu_4 {
  position: absolute;
  left: 145px;
  top: 160px;
}
.qiu_5 {
  position: absolute;
  left: 190px;
  top: 160px;
}
.qiu_6 {
  position: absolute;
  left: 25px;
  top: 120px;
}
.qiu_7 {
  position: absolute;
  left: 175px;
  top: 120px;
}
.qiuafter {
  width: 50px;
  height: 50px;
  display: block;
  background: url(../assets/img/luckDraw/canpin_1.png) no-repeat;
  animation: zhuan 1s linear forwards;
  -webkit-animation: zhuan 1s linear forwards;
  background-size: 100% 100%;
}

/*掉落动画*/
.diaol_1 {
  animation: dialuodn 1s linear 0.9s backwards;
  -webkit-animation: dialuodn 1s linear 0.9s backwards;
}
.diaol_1:after {
  animation-delay: 0.8s;
  -webkit-animation-delay: 0.8s;
}
.diaol_2 {
  animation: dialuodn 1s linear 0.6s backwards;
  -webkit-animation: dialuodn 1s linear 0.6s backwards;
}
.diaol_2:after {
  animation-delay: 0.5s;
  -webkit-animation-delay: 0.5s;
}
.diaol_3 {
  animation: dialuodn 1s linear backwards;
  -webkit-animation: dialuodn 1s linear backwards;
}

.diaol_4 {
  animation: dialuodn 1s linear 1.1s backwards;
  -webkit-animation: dialuodn 1s linear 1.1s backwards;
}
.diaol_4:after {
  animation-delay: 1s;
  -webkit-animation-delay: 1s;
}
.diaol_5 {
  animation: dialuodn 1s linear 0.8s backwards;
  -webkit-animation: dialuodn 1s linear 0.8s backwards;
}
.diaol_5:after {
  animation-delay: 0.7s;
  -webkit-animation-delay: 0.7s;
}
.diaol_6 {
  animation: dialuodn 1s linear 0.4s backwards;
  -webkit-animation: dialuodn 1s linear 0.4s backwards;
}
.diaol_6:after {
  animation-delay: 0.3s;
  -webkit-animation-delay: 0.3s;
}

.diaol_7 {
  animation: dialuodn 1s linear 0.9s backwards;
  -webkit-animation: dialuodn 1s linear 0.9s backwards;
}
.diaol_7:after {
  animation-delay: 0.8s;
  -webkit-animation-delay: 0.8s;
}
.diaol_8 {
  animation: dialuodn 1s linear 0.6s backwards;
  -webkit-animation: dialuodn 1s linear 0.6s backwards;
}
.diaol_8:after {
  animation-delay: 0.5s;
  -webkit-animation-delay: 0.5s;
}

.diaol_9 {
  animation: dialuodn 1s linear 1.1s backwards;
  -webkit-animation: dialuodn 1s linear 1.1s backwards;
}
.diaol_9:after {
  animation-delay: 1s;
  -webkit-animation-delay: 1s;
}
.diaol_10 {
  animation: dialuodn 1s linear 0.2s backwards;
  -webkit-animation: dialuodn 1s linear 0.2s backwards;
}

.diaol_11 {
  animation: dialuodn 1s linear 1.4s backwards;
  -webkit-animation: dialuodn 1s linear 1.4s backwards;
}
.diaol_11:after {
  animation-delay: 1.3s;
  -webkit-animation-delay: 1.3s;
}

.niu_danji .dila_Y {
  width: 110px;
  height: 90px;
  animation: cujpin 0.7s ease-out forwards;
  -webkit-animation: cujpin 0.7s ease-out forwards;
}
.niu_danji .diaL_one {
  width: 85px;
  height: 85px;
  position: relative;
}
.niu_danji .diaL_one:after {
  content: "";
  width: 85px;
  height: 85px;
  display: block;
  background: url(../assets/img/luckDraw/canpin_1.png) no-repeat;
  animation: fanda 0.7s ease-out forwards;
  -webkit-animation: fanda 0.7s ease-out forwards;
  background-size: 100% 100%;
}

.darkbox {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 12;
}
.rulebox,
.prizebox {
  width: 79%;
  height: 74%;
  background: #fff;
  border-radius: 8px;
  position: relative;
  padding: 3%;
}
.prizebox {
  width: 67%;
  height: 74%;
  padding: 3% 10%;
}
.ruleclose,
.prizeboxclose {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  position: absolute;
  right: -15px;
  top: -15px;
}
.ruleclose img,
.prizeboxclose img {
  width: 100%;
  height: 100%;
}
.ruletitle {
  font-size: 14px;
}
.ruledatabody {
  white-space: pre-line;
  text-align: left;
  line-height: 20px;
}
.prizesm {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  overflow-y: auto;
  height: 100%;
  align-content: flex-start;
}
.prizesm::-webkit-scrollbar {
  display: none;
}
.prizesmbox {
  width: 110px;
  height: 138px;
  margin-top: 16px;
}
.prizesmboximg {
  width: 110px;
  height: 110px;
  border-radius: 8px;
  background: #d8d8d8;
}
.prizesmboximg img {
  width: 100%;
  height: 100%;
  border-radius: 8px;
}
.prizesmtitle {
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-top: 8px;
  color: #585b63;
  font-size: 14px;
}
@-webkit-keyframes cujpin {
  0% {
    -webkit-transform: translateY(-100px);
  }
  100% {
    -webkit-transform: translateY(0);
  }
}
@keyframes cujpin {
  0% {
    transform: translateY(-100px);
  }
  100% {
    transform: translateY(0);
  }
}

@keyframes fanda {
  0% {
    transform: scale(0.7);
  }
  100% {
    transform: scale(1);
  }
}
@-webkit-keyframes fanda {
  0% {
    -webkit-transform: scale(0.7);
  }
  100% {
    -webkit-transform: scale(1);
  }
}
.tc_anima {
  animation: title1 0.3s linear;
  -webkit-animation: title1 0.3s linear;
}
@keyframes title1 {
  from {
    opacity: 0;
    transform: scale(0, 0);
  }
  to {
    opacity: 1;
    transform: scale(1, 1);
  }
}
@-webkit-keyframes title1 {
  from {
    opacity: 0;
    -webkit-transform: scale(0, 0);
  }
  to {
    opacity: 1;
    -webkit-transform: scale(1, 1);
  }
}

.wieyi_1 {
  animation: around1 1.5s linear infinite;
  -webkit-animation: around1 1.5s linear infinite;
}

.wieyi_2 {
  animation: around2 1.5s linear infinite;
  -webkit-animation: around2 1.5s linear infinite;
}

.wieyi_3 {
  animation: around3 1.5s linear infinite;
  -webkit-animation: around3 1.5s linear infinite;
}

.wieyi_4 {
  animation: around4 1.5s linear infinite;
  -webkit-animation: around4 1.5s linear infinite;
}
.wieyi_5 {
  animation: around5 1.5s linear infinite;
  -webkit-animation: around5 1.5s linear infinite;
}

.wieyi_6 {
  animation: around6 1.5s linear infinite;
  -webkit-animation: around6 1.5s linear infinite;
}

.wieyi_7 {
  animation: around7 1.5s linear infinite;
  -webkit-animation: around7 1.5s linear infinite;
}

.zuadon_dh {
  animation: around 2s linear backwards;
  -webkit-animation: around 2s linear backwards;
}

@keyframes dialuodn {
  0% {
    transform: translateY(-200%);
    opacity: 0;
  }
  5% {
    transform: translateY(-200%);
  }
  15% {
    transform: translateY(0);
  }
  30% {
    transform: translateY(-100%);
  }
  40% {
    transform: translateY(0%);
  }
  50% {
    transform: translateY(-60%);
  }
  70% {
    transform: translateY(0%);
  }
  80% {
    transform: translateY(-30%);
  }
  90% {
    transform: translateY(0%);
  }
  95% {
    transform: translateY(-14%);
  }
  97% {
    transform: translateY(0%);
  }
  99% {
    transform: translateY(-6%);
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

@-webkit-keyframes dialuodn {
  0% {
    -webkit-transform: translateY(-200%);
    opacity: 0;
  }
  5% {
    -webkit-transform: translateY(-200%);
  }
  15% {
    -webkit-transform: translateY(0);
  }
  30% {
    -webkit-transform: translateY(-100%);
  }
  40% {
    -webkit-transform: translateY(0%);
  }
  50% {
    -webkit-transform: translateY(-60%);
  }
  70% {
    -webkit-transform: translateY(0%);
  }
  80% {
    -webkit-transform: translateY(-30%);
  }
  90% {
    -webkit-transform: translateY(0%);
  }
  95% {
    -webkit-transform: translateY(-14%);
  }
  97% {
    -webkit-transform: translateY(0%);
  }
  99% {
    -webkit-transform: translateY(-6%);
  }
  100% {
    -webkit-transform: translateY(0);
    opacity: 1;
  }
}

@-webkit-keyframes zhuan {
  0% {
    -webkit-transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes zhuan {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes around1 {
  0% {
    transform: translate(0px, 0px);
  }
  20% {
    transform: translate(100px, -10px);
  }
  40% {
    transform: translate(200px, -50px);
  }
  60% {
    transform: translate(50px, -160px);
  }
  80% {
    transform: translate(200px, -110px);
  }
  100% {
    transform: translate(100px, -50px);
  }
}

@keyframes around2 {
  0% {
    transform: translate(0px, 0px);
  }
  10% {
    transform: translate(100px, -100px);
  }
  30% {
    transform: translate(0px, -160px);
  }
  50% {
    transform: translate(150px, -100px);
  }
  80% {
    transform: translate(0px, -150px);
  }
  100% {
    transform: translate(100px, 0px);
  }
}

@keyframes around3 {
  0% {
    transform: translate(0px, 0px);
  }
  25% {
    transform: translate(-50px, -90px);
  }
  50% {
    transform: translate(-70px, -110px);
  }
  80% {
    transform: translate(100px, -120px);
  }
  100% {
    transform: translate(0px, -100px);
  }
}

@keyframes around4 {
  0% {
    -webkit-transform: translate(0px, 0px);
  }
  12% {
    -webkit-transform: translate(-50px, -100px);
  }
  30% {
    -webkit-transform: translate(-50px, -130px);
  }
  60% {
    -webkit-transform: translate(-100px, -30px);
  }
  80% {
    -webkit-transform: translate(50px, -10px);
  }
  100% {
    -webkit-transform: translate(20px, 0);
  }
}

@keyframes around5 {
  0% {
    transform: translate(0px, 0px);
  }
  22% {
    transform: translate(-50px, -150px);
  }
  46% {
    transform: translate(-150px, -105px);
  }
  80% {
    transform: translate(-180px, -10px);
  }
  100% {
    transform: translate(-100px, -105px);
  }
}

@keyframes around6 {
  0% {
    transform: translate(0px, 0px);
  }
  15% {
    transform: translate(50px, -40px);
  }
  30% {
    transform: translate(80px, -120px);
  }
  45% {
    transform: translate(60px, 40px);
  }
  60% {
    transform: translate(100px, -120px);
  }
  75% {
    transform: translate(80px, -50px);
  }
  100% {
    transform: translate(-60px, 40px);
  }
}

@keyframes around7 {
  0% {
    transform: translate(0px, 0px);
  }
  20% {
    transform: translate(-50px, -100px);
  }
  40% {
    transform: translate(-90px, -100px);
  }
  60% {
    transform: translate(-150px, -100px);
  }
  80% {
    transform: translate(-150px, -60px);
  }
  100% {
    transform: translate(0px, -100px);
  }
}
</style>
